<template>
  <div id="app">
    <router-view />
    <!-- <img src="./assets/logo.png"> -->
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>



// WEBPACK FOOTER //
// src/App.vue